var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4710_21628)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 11.0776,
    width: 1.52386,
    height: 18.8141,
    rx: 0.761929,
    transform: "rotate(-45 10 11.0776)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 10.25C16.5875 10.25 16.25 10.5875 16.25 11V14C16.25 14.4125 16.5875 14.75 17 14.75C17.4125 14.75 17.75 14.4125 17.75 14V11C17.75 10.5875 17.4125 10.25 17 10.25Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8473 13.4375C20.5698 13.145 20.5623 12.6875 20.8548 12.395C21.1548 12.095 21.6498 12.1025 21.9348 12.41C23.0598 13.61 23.7498 15.215 23.7498 16.9925C23.7498 17.8509 23.5896 18.672 23.2975 19.4273C23.1325 19.8542 22.6093 19.9777 22.233 19.7171C21.9162 19.4977 21.8169 19.0794 21.9474 18.7168C22.1568 18.135 22.2649 17.51 22.2498 16.865C22.2198 15.5375 21.6948 14.3375 20.8473 13.4375Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7498 17C11.7498 19.925 14.1348 22.2875 17.0673 22.2425C18.6965 22.2254 20.1665 21.4219 21.1215 20.2053L22.2498 21.2368C20.9698 22.8194 18.9897 23.8117 16.7823 23.7425C13.1223 23.63 10.1448 20.465 10.2498 16.805C10.3023 15.1025 10.9848 13.565 12.0723 12.41C12.3573 12.1025 12.8448 12.095 13.1448 12.395C13.4298 12.68 13.4298 13.1375 13.1523 13.43C12.2823 14.3675 11.7498 15.62 11.7498 17Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4710_21628"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisable);
export default __webpack_public_path__ + "static/media/disable.46802cae49b29366af6a3342a9d540bc.svg";
export { ForwardRef as ReactComponent };